<!-- Иконка удаления: корзина для destructive-действий -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M3 6H21"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M8 6V4C8 3.45 8.45 3 9 3H15C15.55 3 16 3.45 16 4V6"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 6 18 20C17.92 21.1 17.1 22 16 22H8C6.9 22 6.08 21.1 6 20L5 6"
      :stroke="stroke"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M10 11V17M14 11V17"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "TrashIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
